import { type RouteLocationNormalized } from 'vue-router';

export type RouteWithQuery = Pick<RouteLocationNormalized, 'query'>;

export function isFeatureEnabled(key: SupportedFeatures, route: RouteWithQuery): boolean {
  const featuresFromRoute = getFeaturesFromRoute(route);

  return featuresFromRoute.includes(key);
}

function getFeaturesFromRoute(route: RouteWithQuery): string[] {
  const features = (route?.query?.feature || '') as string;

  return features.split(',').map((feature) => feature.trim());
}

export enum SupportedFeatures {
  DEACTIVATE_REASON_MDOAL = 'useDeactivateReasonModal',
  PERFORMANCE_SCORE_SORTING = 'performanceScoreSorting',
  AI_DIAGNOSIS = 'aiDiagnosis',
  EXPERIMENTAL_TOPLISTING_PRICES = 'experimentalToplistingPrices',
  SHOW_RANKING_CUSTOM_SEARCH = 'showRankingCustomSearch',
  PROJECT_BOOST = 'projectBoost',
  ENABLE_WINNING_MANDATE = 'enableWinningMandate',
}
